import { useRef, useCallback } from 'react';

interface UseColumnResizeOptions {
  onResize: (field: string, width: number) => void;
}

export const useColumnResize = ({ onResize }: UseColumnResizeOptions) => {
  const resizeRef = useRef<{
    field: string;
    startX: number;
    startWidth: number;
  } | null>(null);

  const handleMouseDown = useCallback(
    (e: React.MouseEvent, field: string, currentWidth: number) => {
      e.preventDefault();
      e.stopPropagation();
      
      resizeRef.current = {
        field,
        startX: e.clientX,
        startWidth: currentWidth,
      };

      const handleMouseMove = (moveEvent: MouseEvent) => {
        if (!resizeRef.current) return;
        
        const diff = moveEvent.clientX - resizeRef.current.startX;
        const newWidth = Math.max(50, resizeRef.current.startWidth + diff);
        onResize(resizeRef.current.field, newWidth);
      };

      const handleMouseUp = () => {
        resizeRef.current = null;
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
        document.body.style.cursor = '';
        document.body.style.userSelect = '';
      };

      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
    },
    [onResize]
  );

  return { handleMouseDown };
};







